import { slices } from "@/constants/sliceNames";
import { useSelector } from "react-redux";

const useShouldWait = () => {
  const { loading } = useSelector((state) => state[slices.authorization]);
  const { userRole, userInfo } = useSelector((state) => state[slices.auth]);
  return loading || userRole.length === 0 || Object.keys(userInfo).length === 0;
};

export default useShouldWait;
